<template>
  <div class="px-0 pt-0">
    <v-row>
      <v-col
        cols="12"
        class="bg-image"
        style="background-image: url('/enamorate/landing_portada.png')"
      >
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="8"
        lg="6"
        offset-lg="3"
        class="d-flex justify-center align-center flex-column py-12"
      >
        <h1 class="text-center red-text mt-12 mb-6">
          El camino a tu futuro, está en el amor por tu vocación
        </h1>
        <h3 class="text-center my-6 font-weight-light">
          Encontrar la licenciatura de tus sueños, es encontrar el amor a tu
          futuro. Conoce la oferta educativa, los beneficios de ser Gente
          Vizcaya, y todo el amor que puedes encontrar en tu licenciatura.
        </h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="8"
        lg="6"
        offset-lg="3"
        class="d-flex justify-center align-center flex-column py-6"
      >
        <h3 class="text-center mb-6 font-weight-regular">
          Únete a:
        </h3>
        <h2 class="red-text text-center my-3">
          Entrevistas con alumnos egresados
        </h2>
        <h2 class="red-text text-center my-3">
          Coordinadores de licenciaturas
        </h2>
        <h2 class="red-text text-center my-3">Coordinadores de idiomas</h2>
        <h3 class="text-center my-6 font-weight-light">
          Busca el Facebook de tu Campus Vizcaya más cercano o completa el
          formulario para contactarnos contigo.
        </h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-flex justify-center align-center">
        <v-card
          id="registrate-aqui"
          class="ma-2 ma-sm-6 ma-md-8"
          style="background-color: #f7f7f7"
          width="100%"
        >
          <v-layout
            :row="$vuetify.breakpoint.mdAndUp"
            class="mx-0"
            :column="$vuetify.breakpoint.smAndDown"
          >
            <v-flex
              xs12
              :class="[$vuetify.breakpoint.mdAndUp ? 'px-12 ' : 'pa-2']"
            >
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="12" md="6" class="pr-6">
                    <v-text-field
                      class="mb-5"
                      label="PRIMER NOMBRE*"
                      placeholder="Juan"
                      v-model="information.name_first"
                      type="text"
                      id="name_first"
                    ></v-text-field>
                    <v-text-field
                      class="mb-5"
                      label="SEGUNDO NOMBRE"
                      placeholder="Luis"
                      v-model="information.name_second"
                      type="text"
                      id="name_second"
                    ></v-text-field>
                    <v-text-field
                      class="mb-5"
                      label="APELLIDO PATERNO*"
                      placeholder="López"
                      v-model="information.last_name"
                      type="text"
                      id="lastname"
                    ></v-text-field>
                    <v-text-field
                      class="mb-5"
                      label="APELLIDO MATERNO*"
                      placeholder="Garcia"
                      v-model="information.mother_last_name"
                      type="text"
                      id="lastname"
                    ></v-text-field>
                    <v-text-field
                      class="mb-5"
                      label="CORREO ELECTRÓNICO*"
                      v-model="information.email"
                      placeholder="correo@ejemplo.com"
                      type="email"
                      id="email"
                    ></v-text-field>
                    <v-text-field
                      class="mb-5"
                      label="NÚMERO TELEFÓNICO*"
                      placeholder="(123)-123-1212"
                      v-model="information.phone"
                      v-mask="'(###)-###-####'"
                      type="phone"
                      id="phone"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="6" class="pl-6">
                    <v-text-field
                      class="mb-5"
                      label="LOCALIDAD*"
                      placeholder="Tepic"
                      v-model="information.localidad"
                      id="localidad"
                    ></v-text-field>
                    <v-select
                      class="mt-8 mb-4"
                      :items="cities"
                      label="EN EL PLANTEL*"
                      hide-details
                      v-model="campusSelected"
                      item-text="name"
                      item-value="name"
                    >
                      <option :value="campus"></option>
                    </v-select>
                    <p class="body-1 text-uppercase">
                      Escoge el grado de tu interés:*
                    </p>
                    <v-checkbox
                      v-show="
                        information.campus == 'Tepic' ||
                          information.campus == 'Piedras Negras'
                      "
                      dense
                      hide-details
                      v-model="information.preescolar"
                      label="Preescolar"
                    ></v-checkbox>
                    <v-checkbox
                      dense
                      v-show="information.campus == 'Tepic'"
                      hide-details
                      v-model="information.primaria"
                      label="Primaria"
                    ></v-checkbox>
                    <v-checkbox
                      dense
                      hide-details
                      v-model="information.secundaria"
                      label="Secundaria"
                    ></v-checkbox>
                    <v-checkbox
                      dense
                      hide-details
                      v-model="information.preparatoria"
                      label="Preparatoria"
                    ></v-checkbox>
                    <v-textarea
                      class="mt-5"
                      label="MENSAJE*"
                      rows="6"
                      counter="200"
                      no-resize
                      v-model="information.message"
                      id="lastname"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="pb-2">
                <v-layout
                  :row="$vuetify.breakpoint.mdAndUp"
                  :column="$vuetify.breakpoint.smAndDown"
                  :reverse="$vuetify.breakpoint.smAndDown"
                >
                  <div
                    class="flex-grow-1"
                    v-if="$vuetify.breakpoint.mdAndUp"
                  ></div>
                  <v-btn
                    rounded
                    :x-large="$vuetify.breakpoint.lgAndUp"
                    text
                    class="px-5"
                    @click="clearFields()"
                    >Cancelar</v-btn
                  >
                  <v-btn
                    rounded
                    :x-large="$vuetify.breakpoint.lgAndUp"
                    color="primary"
                    class="px-5"
                    @click="submit()"
                    :disabled="isLoading"
                    >Enviar formulario</v-btn
                  >
                </v-layout>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        class="bg-image-pie mt-12"
        :style="[
          $vuetify.breakpoint.mdAndUp
            ? { 'background-image': 'url(/enamorate/landing_pieweb.png)' }
            : { 'background-image': 'url(/enamorate/landing_piemovil.png)' },
        ]"
      >
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" :color="snackbarColor">
      {{ snackbarText }}
      <v-btn color="white" dark text @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import { mask } from "vue-the-mask";
import { mapState } from "vuex";
import axios from "axios";
export default {
  directives: {
    mask,
  },
  mounted() {
    let countDownDate = new Date("Nov 20, 2020 00:00:00").getTime();
    let self = this;
    // Update the count down every 1 second
    let x = setInterval(function() {
      // Get today's date and time
      let now = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      let days = Math.floor(distance / (1000 * 60 * 60 * 24));
      let hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Display the result in the element with id="demo"
      self.days = days;
      self.hours = hours;
      self.minutes = minutes;
      self.seconds = seconds;

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
      }
    }, 1000);
  },
  data: () => ({
    snackbar: false,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    snackbarColor: "info",
    snackbarText: "",
    fromlink: null,
    isLoading: false,
    publicPath: process.env.BASE_URL,
    campusSelected: "",
    offsetTop: 0,
    information: {
      name_first: "",
      name_second: "",
      last_name: "",
      mother_last_name: "",
      phone: "",
      email: "",
      campus: "",
      carrer: "",
      horarios: "",
      localidad: "",
      message: "Me interesa toda la información sobre Enamórate Vizcaya",
      licenciatura: false,
      posgrado: false,
      otros: false,
      preescolar: false,
      primaria: false,
      secundaria: false,
      preparatoria: false,
      escolaridad: "",
      school: "",
      way: "",
    },
  }),
  computed: {
    ...mapState({
      campus: (state) => state.cities.campus,
      campus_all: (state) => state.cities.campus,
      city_options: (state) => state.cities.city_options,
      city_selected: (state) => state.cities.city_selected,
      cities: (state) => state.cities.cities,
      vida: (state) => state.cities.vida,
      link_location: (state) => state.cities.link_location,
      link_information: (state) => state.cities.link_information,
    }),
    marginTop() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "-15vh";
      } else {
        ("-10vh");
      }
    },
  },
  methods: {
    validateEmail(email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validatePhone(number) {
      let phone = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
      return phone.test(number);
    },
    validateFields() {
      if (
        this.information.name_first != "" &&
        this.information.last_name != "" &&
        this.information.mother_last_name != "" &&
        this.information.phone != "" &&
        this.information.email != "" &&
        this.campusSelected != "" &&
        this.information.localidad != "" &&
        this.information.message != ""
      ) {
        this.valid = true;
      } else {
        this.valid = false;
        this.snackbarText =
          "Favor de completar todos los campos marcados con asterisco";
        this.snackbar = true;
        this.snackbarColor = "dark";
      }
    },
    submit() {
      this.information.escolaridad = "";
      let escola = false;
      if (this.information.preescolar) {
        escola = true;
      }
      if (this.information.primaria) {
        escola = true;
      }
      if (this.information.secundaria) {
        escola = true;
      }
      if (this.information.preparatoria) {
        escola = true;
      }
      if (!escola) {
        this.snackbarText =
          "Favor de completar todos los campos marcados con asterisco";
        this.snackbar = true;
        return;
      }
      this.validateFields();
      if (this.valid) {
        if (this.validateEmail(this.information.email)) {
          this.emailValid = true;
        } else {
          this.emailValid = false;
          this.snackbarText = "Favor de ingresar un email válido";
          this.snackbar = true;
        }
        if (
          this.validatePhone(this.information.phone) &&
          String(this.information.phone).length == 14
        ) {
          this.phoneValid = true;
        } else {
          this.phoneValid = false;
          this.snackbarText = "Favor de ingresar un número válido";
          this.snackbar = true;
        }
      }
      if (this.valid && this.emailValid && this.phoneValid) {
        if (this.information.primaria) {
          this.information.escolaridad += "Primaria ";
        }
        if (this.information.preescolar) {
          this.information.escolaridad += "Preescolar ";
        }
        if (this.information.secundaria) {
          this.information.escolaridad += "Secundaria ";
        }
        if (this.information.preparatoria) {
          this.information.escolaridad += "Preparatoria ";
        }
        this.sendInfoData();
      }
    },
    sendInfoData() {
      let self = this;
      self.isLoading = true;
      let formData = new FormData();
      formData.append("firstname", this.information.name_first);
      formData.append("secondname", this.information.name_second);
      formData.append("lastname", this.information.last_name);
      formData.append("lastname1", this.information.mother_last_name);
      formData.append("email", this.information.email);
      formData.append("phone", this.information.phone);
      formData.append("municipality", this.information.localidad);
      formData.append("campus", this.campusSelected);
      formData.append("message", this.information.message);
      formData.append("carreer", "Enamórate Vizcaya");
      formData.append("subject", "Enamórate Vizcaya - Informes");
      formData.append("information_by_level", this.information.escolaridad);
      formData.append("procedence", "Enamórate Vizcaya");
      formData.append("comunication", "Enamórate Vizcaya");
      formData.append("webpage", "Colegio");
      axios({
        method: "post",
        url: "https://informesuva.tidingo.com/api/create-information",
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        },
      })
        .then(function(response) {
          if (response.data.status == 200) {
            self.snackbarText =
              "Información enviada, en breve nos comunicaremos contigo";
            self.snackbarColor = "success";
            self.snackbar = true;
            self.clearFields();
          } else {
            self.snackbarText =
              "Ocurrio un error al enviar tu información, intentalo mas tarde";
            self.snackbarColor = "error";
            self.snackbar = true;
            self.clearFields();
          }
          self.isLoading = false;
        })
        .catch(function(error) {
          self.isLoading = false;
        });
    },
    clearFields() {
      this.information = {
        name_first: "",
        name_second: "",
        last_name: "",
        mother_last_name: "",
        phone: "",
        email: "",
        campus: "",
        carrer: "",
        horarios: "",
        localidad: "",
        message: "Me interesa toda la información sobre Enamórate Vizcaya",
        licenciatura: false,
        posgrado: false,
        otros: false,
        escolaridad: "",
        school: "",
        way: "",
      };
    },
    onScroll(e) {
      this.offsetTop = window.scrollY;
    },
  },
  created() {
    window.addEventListener("scroll", this.onScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>
<style>
.red-text {
  color: #af3954;
}
.bg-image {
  width: 100vw;
  height: 120vh;
  background-position: center;
  background-size: cover;
}
.bg-image-pie {
  height: 100vh;
  background-position: center;
  background-size: cover;
}
</style>
